<template>
  <div>
    <div class="l-invite-box">

      <div class="l-invite-container">
        <div>
          <img src="@/assets/images/invite.png" style="width:100%;">
        </div>
        <div style="padding:20px">
          <el-form :model="form_data" label-width="95px" ref="form" :rules="rules" label-position="left" v-loading="loading">
            <el-form-item label="手机号" prop="username">
              <el-input v-model="form_data.username" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="手机验证码" prop="verify_code">
              <el-col :span="14">
                <el-input v-model="form_data.verify_code" autocomplete="off" placeholder="请输入手机验证码"></el-input>
              </el-col>
              <el-col :span="10">
                <el-button type="primary" size="small" style="margin-left:5px;padding-left:10px;padding-right:5px" :disabled="time_dec>0" @click="sendVerifyCode">
                  <span v-show="time_dec<=0">发送验证码</span>
                  <span v-show="time_dec>0">{{time_dec}}S后重发</span>
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="pwd">
              <el-input type="password" v-model="form_data.pwd" autocomplete="off" placeholder="请输入登录密码"></el-input>
            </el-form-item>

            <el-form-item label="密码确认" prop="re_pwd">
              <el-input type="password" v-model="form_data.re_pwd" autocomplete="off" placeholder="请再次输入登录密码"></el-input>
            </el-form-item>

            <el-form-item label="工号" prop="e_num">
              <el-input v-model="form_data.e_num" autocomplete="off" placeholder="请输入工号(选填)"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="form_data.position" autocomplete="off" placeholder="请输入职位(选填)"></el-input>
            </el-form-item>

            <el-form-item label="" style="margin-top:20px">
              <el-button type="primary" :loading="submitting" @click="handleSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
  import initGeetest from '../../assets/js/gt.js'
  export default {
    name: 'l-user-invite',
    components: {
    },
    data() {
      return {
        loading: false,
        sms_init: false,
        captchaObj: {},
        geetest_challenge: '',
        geetest_validate: '',
        geetest_seccode: '',
        data: {},
        time_dec: 0,
        form_data: {
          username: '',
          org_id: '',
          name: '',
          pwd: '',
          re_pwd: '',
          e_num: '',
          position: '',
          verify_code: '',
        },

        rules: {
          name: [
            { required: true, message: '角色名称不能为空', trigger: 'change' }
          ],
          username: [
            { required: true, message: '手机号不能为空', trigger: 'change' }
          ],
          verify_code: [
            { required: true, message: '请输入验证码', trigger: 'change' }
          ],
          pwd: [
            { required: true, message: '密码不能为空', trigger: 'change' }
          ],
          re_pwd: [
            { required: true, message: '密码确认不能为空', trigger: 'change' }
          ],

        },
        //提交按钮是否显示加载中
        submitting: false,
      }
    },

    mounted() {
      this.smsInit();
      this.getData();
    },

    methods: {
      //初始化短信验证
      smsInit() {
        this.$_invoke('sms_init', {}).then((data) => {
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: "bind",
            offline: !data.success
          }, (captchaObj) => {
            this.captchaObj = captchaObj;
            this.sms_init = true;
          });
        });
      },
      //获取数据
      getData() {
        this.loading = true;
        this.$_invoke('queryStrEncry_getInviteData', { tag: this.$route.params.tag }).then(ret => {
          this.data = ret;
          this.form_data.org_id = ret.org_id;
        }).finally(() => {
          this.loading = false;
        })
      },

      //发送验证码
      sendVerifyCode() {
        this.$refs.form.validateField('username', (valid) => {
          if (!valid) {
            this.captchaObj.verify();
            this.captchaObj.onSuccess(() => {
              var result = this.captchaObj.getValidate();
              this.$_invoke('sms_regVerify', {
                mobile: this.form_data.username,
                org_id: this.form_data.org_id,
                geetest_challenge: result.geetest_challenge,
                geetest_validate: result.geetest_validate,
                geetest_seccode: result.geetest_seccode,
              }).then(() => {
                this.$_msg.success('短信发送成功');
                this.time_dec = 60;
                this.timeDec();
              }).finally(() => {
                this.loading = false;
              })
            });
          }
        });

      },

      //倒计时
      timeDec() {
        if (this.time_dec <= 0) {
          return;
        }
        setTimeout(() => {
          this.time_dec--;
          this.timeDec();
        }, 1000);
      },

      //提交数据
      handleSubmit() {
        if (this.loading) return;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitting = true;
            this.form_data.tag = this.$route.params.tag;
            this.$_invoke('user_inviteSave', this.form_data).then(() => {
              //   this.$_msg.success('填写成功！');
              this.$router.push('/invite/success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .l-invite-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    bottom: 0;
    overflow: auto;
  }

  .l-invite-container {
    max-width: 760px;
    margin: 0 auto;
    // padding: 20px 20px;
  }
</style>